import React, { useState } from "react";
import SliderPanel from "./../../../components/SliderPanel/SliderPanel";
import { Formik } from "formik";
import { Form } from "react-bootstrap";
import { DragDropContext } from "react-beautiful-dnd";
import {
  CensusAndPayroll,
  Census,
  Payroll,
  fileMetaData,
  mapperFormFields,
  passthroughFileMetaData,
} from "../../../utils";
import { isNull, isEqual, get } from "lodash-es";
import SourceFieldPanelComponent from "./../../../components/SourceFieldPanelComponent/SourceFieldPanelComponent";
import TargetSection from "./TargetSection";
import TargetValueSection from "./TargetValueSection";
import {
  fileNameTypes,
  jsonToStringConverter,
  manageMapperFormNames,
  stringToJsonConverter,
} from "./../../../utils/constants/mapper";
import MappedFieldSetup from "./MappedFieldSetup";
import PreviewSection from "./PreviewSection";
import PreviewSectionForConfigureOutput from "./PreviewSectionForConfigureOutput";
import { manageMapperStore } from "../../../contexts";
import { useContext } from "react";
import { isEmpty } from "lodash";

const ConfigureFileSlider = (props) => {
  const {
    isSplitConfigured = false,
    slideShow,
    setSlideShow,
    configureValue,
    setConfigureValue,
    dataModel,
    fileName,
    saveData,
    setSaveData,
    mappedData,
    setFieldValuesParent,
    setMappedData,
    setCheckSubmit,
    isDefaultHeader
  } = props;

  const { state, dispatch } = useContext(manageMapperStore);
  const apiData = get(state, "api.data", {});
  const headerMapJson = get(apiData, "headerMapJson", null);
  let deserializeHeaderMapJson = !isEmpty(headerMapJson)
    ? JSON.parse(headerMapJson)
    : null;
  deserializeHeaderMapJson = deserializeHeaderMapJson?.map((data) => {
    return {
      ...data,
      displayName: `@${data.fieldName?.substring(1)}`,
    };
  });
  const SourceData = deserializeHeaderMapJson?.concat(passthroughFileMetaData);
  const [fieldArrayName, setFieldArrayName] = useState(null);
  const [clickToSelect, setClickToSelect] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const showSource = false;
  const formName = manageMapperFormNames.MAP_AND_TRANSFORM_OUTPUT;
  const fields = mapperFormFields[formName];

  const onClose = () => {
    setSlideShow(false);
    setClickToSelect(false);
    setValidationError(false);
    setCheckSubmit(true);
  };

  const sections = () => {
    switch (dataModel) {
      case 4:
        return [
          {
            name: "FileMetaData",
            fields: fileMetaData,
          },
        ];
    }
  };

  const [section] = sections();
  const handleOnDragStart = (res) => {};

  const handleOnDragUpdate = (update) => {};

  const handleOnDragEnd = (result, values, setFieldValue) => {
    setFieldArrayName(null);
    setClickToSelect(false);
    const { draggableId } = result;
    if (result.destination == null) {
      return;
    }
    if (isEqual(result.destination, result.source)) {
      return;
    }
    let section = sections();
    let draggedData = section[0]?.fields.find((e, i) => {
      if (e.isCollection) {
        let data = e.childObjectMaps.find((x) => x.propertyName == draggableId);
        return data;
      } else return e.propertyName == draggableId;
    });
    if (draggedData.isCollection) {
      let temp = {
        ...draggedData.childObjectMaps.find(
          (x) => x.propertyName == draggableId
        ),
        isCollection: true,
        isCollectionParent: draggedData?.isCollection,
        propertyNameParent: draggedData?.propertyName,
      };
      draggedData = temp;
    }
    let droppableId = get(result, "destination.droppableId");
    setFieldValue(droppableId, {
      ...draggedData,
      path: draggedData?.propertyName,
      value: draggedData?.datum ?? 1000,
    });
  };

  const onFormSubmit = (values) => {
    setCheckSubmit(true);
    const value = jsonToStringConverter(values?.valueData);
    if (
      values?.valueData.value == null ||
      (values?.valueData.parameterType == 2 &&
        (value.includes("null") || value.includes("undefined")))
    )
      setValidationError(true);
    else {
      if(isDefaultHeader)
        setFieldValuesParent("defaultHeaderName", value);
      else
        setFieldValuesParent("fileName", value);
      setSlideShow(false);
      setValidationError(false);
    }
  };
  return (
    slideShow && (
      <Formik
        initialValues={{
          valueData: ![undefined, "", null].includes(fileName)
            ? stringToJsonConverter(fileName, section, SourceData)
            : {
                parameterType: 2,
                value: null,
              },
        }}
        enableReinitialize
        onSubmit={onFormSubmit}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          values,
          setValues,
          ...rest
        }) => {
          return (
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={rest.submitCount > 0}
            >
              <SliderPanel
                flair="select-investment-merger-scroll"
                isOpen={slideShow}
                size="75"
                showCancelButton={true}
                showSave={true}
                showCancel={false}
                backdropClicked={() => onClose()}
                onSave={() => onFormSubmit(values)}
                // onSave={handleSubmit}
                onClose={() => onClose()}
              >
                <div style={{ display: "flex" }}>
                  <div style={{ marginTop: "-10px" }}>Header</div>
                </div>
                <div className="horizontalLineFieldSetup"></div>

                <DragDropContext
                  onDragStart={handleOnDragStart}
                  onDragUpdate={handleOnDragUpdate}
                  onDragEnd={(x) => handleOnDragEnd(x, values, setFieldValue)}
                >
                  <div style={{ display: "flex" }}>
                    <SourceFieldPanelComponent
                      sections={sections()}
                      handleOnDragEnd={handleOnDragEnd}
                      fieldArrayName={fieldArrayName}
                      clickToSelect={clickToSelect}
                      showSource={showSource}
                    />
                    <div
                      style={{
                        width: "100%",
                        marginLeft: showSource ? "300px" : "0px",
                      }}
                    >
                      <TargetValueSection
                        deserializeHeaderMapJson={deserializeHeaderMapJson}
                        isSplitConfigured={isSplitConfigured}
                        forFileNameConfigure={true}
                        fields={fields}
                        parameterTypes={fileNameTypes}
                        clickToSelect={clickToSelect}
                        setClickToSelect={setClickToSelect}
                        setFieldArrayName={setFieldArrayName}
                        headerError={validationError}
                        valueError={validationError}
                      />
                    </div>

                    <PreviewSectionForConfigureOutput
                      deserializeHeaderMapJson={deserializeHeaderMapJson}
                      values={values}
                      fields={fields}
                      showSource={showSource}
                    />
                  </div>
                </DragDropContext>
              </SliderPanel>
            </Form>
          );
        }}
      </Formik>
    )
  );
};

export default ConfigureFileSlider;
